export type NextFetchInit = RequestInit & {
  next?: {
    revalidate?: number | false;
    tags?: readonly string[];
  };
};
export type GenericConfig = Record<string, unknown>;

type PickStartsWith<T extends object, S extends string> = {
  [K in keyof T as K extends `${S}${infer _R}` ? K : never]: T[K];
};

export type ClientConfig<T extends GenericConfig> = PickStartsWith<
  T,
  "CLIENT_"
>;

const toClientConfig = <T extends GenericConfig>(config: T): ClientConfig<T> =>
  Object.fromEntries(
    Object.entries(config).filter(([key]) => key.startsWith("CLIENT_")),
  ) as ClientConfig<T>;

export const buildConfig = <T extends GenericConfig>(configUrl: string) => {
  const config = async (): Promise<T> => {
    const response = await fetch(configUrl, {
      next: {
        tags: ["config"],
      },
    } as NextFetchInit);
    return (await response.json()) as Promise<T>;
  };

  const clientConfig = async () => toClientConfig(await config());

  return {
    clientConfig,
    config,
  };
};
export { buildProvider } from "./client";
